import { render, staticRenderFns } from "./EditNewsTagModal.vue?vue&type=template&id=b1ffb0c4&"
import script from "./EditNewsTagModal.vue?vue&type=script&lang=js&"
export * from "./EditNewsTagModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports